import { WrapperAmplitudeCompanyTab } from "components/company/v3/WrapperCompany";
import BrazilianAboutBox from "components/company/v3/brazilian/boxes/BrazilianAboutBox";
import BrazilianCardsContent from "components/company/v3/brazilian/contents/about/BrazilianCardsContent";
import BrazilianPageLayout from "components/company/v3/layouts/BrazilianPageLayout";
import { CompanyAboutTabEnum } from "components/company/v3/menu/enums";
import BrazilianIssuerSeo from "components/company/v3/seo/BrazilianIssuerSeo";
import SetHttpStatusCode from "lib/http/SetHttpStatusCode";
import getQueryStringValue from "lib/utils/getQueryStringValue";
import type { NextPage } from "next";
import { parseAsStringEnum, useQueryState } from "nuqs";
import NotFound from "pages/404";
import { useIntl } from "react-intl";
import { format } from "util";

interface BrazilianAboutPageProps {
  tickerSymbol: string | null;
}

const BrazilianAboutPage: NextPage<BrazilianAboutPageProps> = function BrazilianAboutPage({ tickerSymbol }) {
  const intl = useIntl();
  const [tab, setTab] = useQueryState(
    "tab",
    parseAsStringEnum<CompanyAboutTabEnum>(Object.values(CompanyAboutTabEnum)).withDefault(CompanyAboutTabEnum.ABOUT),
  );

  const normalizedTickerSymbol = (tickerSymbol || "").toUpperCase();

  if (!normalizedTickerSymbol || normalizedTickerSymbol.length > 8 || /^([0-9]+)$/.test(normalizedTickerSymbol)) {
    return (
      <>
        <SetHttpStatusCode httpStatus={404} />
        <NotFound />
      </>
    );
  }

  return (
    <BrazilianPageLayout tickerSymbol={normalizedTickerSymbol}>
      <WrapperAmplitudeCompanyTab category="Ações" tab={tab} tickerSymbol={normalizedTickerSymbol}>
        <BrazilianAboutBox
          key={format("about/%s/%s", normalizedTickerSymbol, tab)}
          tickerSymbol={normalizedTickerSymbol}
          tab={tab}
          onChangeTab={setTab}
        >
          <BrazilianIssuerSeo
            tickerSymbol={normalizedTickerSymbol}
            title={intl.formatMessage({ defaultMessage: "Sobre", id: "nicxtA", description: "Título da página - SEO" })}
          />
          <BrazilianCardsContent />
        </BrazilianAboutBox>
      </WrapperAmplitudeCompanyTab>
    </BrazilianPageLayout>
  );
};

BrazilianAboutPage.getInitialProps = async ({ query }) => ({
  tickerSymbol: getQueryStringValue(query, "tickerSymbol"),
});

export default BrazilianAboutPage;
